import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Injectable, Inject } from "@angular/core";
import { ENVIRONMENT_TOKEN, Environment } from "@app/singletons.module";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (window.location.hostname.includes("cemexgo.com")) {
      window.location.href = `https://${window.location.hostname}/login`;
      return false;
    }
    return true;
  }
}
